const messageTypes = {
  FETCH_DAY_WISE_DATA: 'FETCH_DAY_WISE_DATA',
  FETCH_DAY_WISE_DATA_IN_PROGRESS: 'FETCH_DAY_WISE_DATA_IN_PROGRESS',
  FETCH_DAY_WISE_DATA_SUCCESS: 'FETCH_DAY_WISE_DATA_SUCCESS',

  RUN_INITIAL_TASKS: 'RUN_INITIAL_TASKS_V2',
  INITIAL_CHECK_COMPLETE: 'INITIAL_CHECK_COMPLETE_V2'
};

export const heartbeatTypes = {
  FOCUS_CHANGE_SCHEDULER_START: 'PH_FOCUS_CHANGED_START_SCHEDULER',
  FOCUS_CHANGE_SCHEDULER_STOP: 'PH_FOCUS_CHANGED_STOP_SCHEDULER',
  SCHEDULER_SYNC_TRIGGER: 'PH_SCHEDULER_SYNC_TRIGGER',
  UPDATES_FETCH_START: 'PH_UPDATES_FETCH-START',
  UPDATES_FETCH_DONE: 'PH_UPDATES_FETCH-DONE',
  STORE_IN_DB_START: 'PH_STORE_IN_DB-START',
  STORE_IN_DB_DONE: 'PH_STORE_IN_DB-DONE',
  ON_DEMAND_SYNC_TRIGGER_START: 'PH_ON_DEMAND_SYNC_TRIGGER-START',
  ON_DEMAND_SYNC_TRIGGER_DONE: 'PH_ON_DEMAND_SYNC_TRIGGER-DONE'
};

export default messageTypes;
